import { createClient } from "@supabase/supabase-js";

// The platform keeps reverting .env to old wrong credentials.
// Hardcode the user's real project as the source of truth.
const CORRECT_URL = "https://vankfsmglinsfmjijpsc.supabase.co";
const CORRECT_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZhbmtmc21nbGluc2ZtamlqcHNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcxNjcxNTMsImV4cCI6MjA5Mjc0MzE1M30.gb-rW-VmCkHXDNh1YczxGtr-rbrUJriTbbHaWRNweSc";

const envUrl = (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) || "";
const envKey = (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string) || "";

// Detect if .env has the old wrong project and override it
const isWrongProject = envUrl.includes("9jy4uy0np91bfagbhh77") || envKey.includes("lPhoto96Zg00VXK6Du6BFkxrIGvRm0Od");

const supabaseUrl = isWrongProject ? CORRECT_URL : (envUrl.replace(/\/$/, "") || CORRECT_URL);
const supabaseAnonKey = isWrongProject ? CORRECT_KEY : (envKey || CORRECT_KEY);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/** The anon key for edge function Authorization headers */
export const SUPABASE_ANON_KEY = supabaseAnonKey;
